import ApiBase from './Api'

export type DeployInfoType = {
    branchName: string
    deployTime: string | null
}

const DEFAULT_DEPLOY_INFO: DeployInfoType = { branchName: 'unknown', deployTime: new Date().toISOString() }

class DeployInfoApi extends ApiBase {
    async getServerDeployInfo() {
        const response = await this._getRequest('/deployinfo')
        return response as DeployInfoType
    }

    async getClientDeployInfo() {
        try {
            const response = await fetch('/deployinfo.json')
            if (response.ok) {
                const data = await response.json()
                return data as DeployInfoType
            } else {
                console.warn('Failed to fetch deployinfo.json (using defaults):', response.status)
            }
        } catch (error) {
            console.error('Error loading deployinfo.json:', error)
        }

        return DEFAULT_DEPLOY_INFO
    }
}

export default DeployInfoApi
